import { render, staticRenderFns } from "./Tip8.vue?vue&type=template&id=d072e1b2&scoped=true&lang=pug"
import script from "./Tip8.vue?vue&type=script&lang=ts"
export * from "./Tip8.vue?vue&type=script&lang=ts"
import style0 from "./Tip8.vue?vue&type=style&index=0&id=d072e1b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d072e1b2",
  null
  
)

export default component.exports